<div class="card" *blockUI="'section-block'">
    <div class="row">
        <div class="col-12 mb-50 ml-2 mt-2">
            <h1>{{getTransactionName(kindId)}}</h1>
        </div>
        <div class="col-md-6 col-12">

            <div class="d-flex justify-content-between align-items-center m-1">
                <label class="d-flex align-items-center">
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                        (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-md-6 col-12 d-flex justify-content-md-end">
            <div class="btn-group mr-1 mt-1">
                <div ngbDropdown>
                    <button ngbDropdownToggle class="btn btn-primary" type="button" id="dropdownMenuButton"
                        rippleEffect>
                        İşlem Seçiniz
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                        <a ngbDropdownItem (click)="onSelectKind(8)">Teklif</a>
                        <a ngbDropdownItem (click)="onSelectKind(6)">Satış</a>
                        <a ngbDropdownItem (click)="onSelectKind(5)">Alış</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ngx-datatable #tableRowDetails [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap"
        style="cursor: pointer;" [limit]="selectedSize" [messages]="{ 
      emptyMessage: 'Veri Yok',
      totalMessage: 'Toplam', 
      selectedMessage: 'Seçili'
    }" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true" (activate)="onActivate($event)">

        <ngx-datatable-row-detail [rowHeight]="rowHeight" [width]="600">
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
                <div class="ml-25 pl-1 pt-25" *blockUI="'section-block2'">
                    <table class="table table-responsive">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Ürün Adı</th>
                                <th>Adet</th>
                                <th>Fiyat</th>
                                <th>İndirim Oranı</th>
                                <th>Vergi</th>
                                <th>Toplam</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of products; let i = index">
                                <td>{{i + 1}}</td>
                                <td>{{item.name | slice:0:20}} {{ item.name.length > 24 ? '...' : '' }}</td>
                                <td>{{item.productCount}}</td>
                                <td>{{item.productPrice | number:'1.2-2'}}</td>
                                <td>{{item.discountRate}}</td>
                                <td>{{item.taxRate}}</td>
                                <td>
                                    {{ calculateTotal(item.productCount, item.productPrice, item.discountRate, item.taxRate) | number:'1.2-2' }}
                                </td>
                            
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </ngx-datatable-row-detail>

        <ngx-datatable-column [width]="450" [resizeable]="false" [sortable]="false" [draggable]="false"
            *blockUI="'section-block2'" [canAutoResize]="false">
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
                <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded"
                    [class.datatable-icon-down]="expanded" title="Expand/Collapse Row"
                    (click)="rowDetailsToggleExpand(row)">
                </a>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="No" prop="no"></ngx-datatable-column>
        <ngx-datatable-column name="Oluşturan Kişi">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.appUserName}} {{row.appUserLastName}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Geçerlilik Süresi">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.validtiyDate | date:'dd.MM.yyyy'}}
            </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span></ng-template>
                    </ngb-pagination>
                </div>

            </ng-template>

        </ngx-datatable-footer>
    </ngx-datatable>
</div>